<template>
    <div class="loader" v-if="isVisible">
      <div class="spinner"></div>
    </div>
  </template>
  
  <script setup>
    import { ref, onMounted, onUnmounted } from 'vue';
    import { spinnerLoader } from '../plugins/spinnerLoader';
    
    const isVisible = ref(false);
    
    onMounted(() => {
      spinnerLoader.register(isVisible);
    });
    
    onUnmounted(() => {
      spinnerLoader.unregister(isVisible);
    });
  </script>
  
  <style scoped>
  .loader {
    position: fixed;
    bottom: 80px;
    left: 50%;
    margin-left: 15px;
    z-index: 99999;
    background-color: #fff;
    border-radius: 50px;
    padding: 10px;
    box-shadow: 0px 0px 40px rgba(0,0,0,0.4);
  }

  .menu_opened .loader {
    margin-left: 110px;
  }

  .dark .loader {
    background-color: #0c0e11;
  }
  
  .spinner {
    border: 4px solid rgba(0,0,0,0.1);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border-left-color: #583a8e;
    animation: spin 1s ease infinite;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media screen and (max-width: 991px){
    .loader {
      margin-left: -25px;
      bottom: 20px;
    }

    .spinner {
      width: 30px;
      height: 30px;
    }
  }
  </style>